
<template>
  <div>
    <!-- <financial-consolidation :client_id='client_id'></financial-consolidation> -->
    <dialog-reversal v-if="new_reversal" @close="new_reversal = false" @done="handleReversalCreated"></dialog-reversal>

    <v-row>
  
      <!--  FILTROS -->
      <v-col cols="12" class="py-0">
        <div v-if="historic.length">
          <v-divider></v-divider>
          <div :class="['d-flex align-center', $vuetify.breakpoint.smAndUp ? 'px-8' : '']">
            <v-btn small :outlined="filter != null"  class="mx-2 rounded-md" color="primary" @click="filter = null">
              Todos
            </v-btn>
            <v-btn small :outlined="filter != 'buy'"  class="mx-2 rounded-md" color="primary" @click="filter = 'buy'">
              Compras
            </v-btn>
            <v-btn small :outlined="filter != 'pay'"  class="mx-2 rounded-md" color="primary" @click="filter = 'pay'">
              Pagamentos
            </v-btn>
            <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Pesquisar" class="px-3"></v-text-field>
            <div v-if="can_use_reversal">
              <v-btn small class="mx-2 py-1 white--text" color="deep-orange" @click="new_reversal = true"><v-icon small class="mx-1">mdi-cash-refund</v-icon>Criar estorno</v-btn>
            </div>
          </div>
          <v-divider></v-divider>
        </div>
      </v-col>
      <!--  FILTROS -->
    </v-row>
    <v-row>

      <!-- TIME LINE -->
      <v-col cols="12" class="py-0">
        <!-- <v-timeline dense clipped v-if="filtered_historic.length > 0" class="pt-0"> -->
          <v-virtual-scroll v-if="filtered_historic.length > 0" height="420" :item-height="$vuetify.breakpoint.mdAndUp ? 58 : ($vuetify.breakpoint.smAndUp ? 100 : 130)" :items="filtered_historic" class="mx-1" bench="0">
            <template v-slot:default="{ item, idx }">

              <v-list-item :key="idx" v-if="true">
                <!-- <v-list-item-action>
                  <v-icon :color="financial_data[item.type].dot_color" >{{ financial_data[item.type].dot_icon }}</v-icon>
                </v-list-item-action> -->
                <v-list-item-content>
                  <ItemHistoricHeader :hf="item" @itemClicked="itemClicked" class="pl-4"></ItemHistoricHeader>
                </v-list-item-content>
                <v-list-item-action>
                  
                  <v-btn depressed small @click="openItemDialog(item)">Detalhes<v-icon color="orange darken-4" right >mdi-open-in-new</v-icon></v-btn>
                  
                </v-list-item-action>
              </v-list-item>
              <v-divider></v-divider>

              <!-- <v-expansion-panels v-model="idx" multiple v-if="false">
                <div class="mb-4 pb-4 elevation-0" style="width:100%;">
                  <template>
                    <v-timeline-item 
                      class="mb-3" style="width: 100%" 
                      :color="financial_data[item.type].dot_color" 
                      v-show="filter == null || (filter && filter == 'buy' && (item.order_id || item.wholesale_order_id || item.other_order_id || item.external_order_id)) || (filter && filter == 'pay' && (!item.order_id && !item.wholesale_order_id && !item.other_order_id && !item.external_order_id)) " 
                      :icon="financial_data[item.type].dot_icon" 
                      :key="`${item.kind} ${item.id}` + idx"
                    >
                    {{ panel }}
                      <v-expansion-panel v-if="1">
                        <v-expansion-panel-header class="py-3">
                          <v-row class="px-3">
                            <item-historic-header v-if="1" :hf="item" :is_open="panel.includes(idx)" @itemClicked="itemClicked" ></item-historic-header>
                          </v-row>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <item-historic-content v-if="1" :hf="item" :is_open="panel.includes(idx)" @itemClicked="itemClicked" ></item-historic-content>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-timeline-item>
                  </template>
                </div>
              </v-expansion-panels> -->
            </template>

          </v-virtual-scroll>      
        <!-- </v-timeline> -->
        <v-alert type="warning" :value="true" v-if="!historic.length && !loading" class="ma-6">
          Não possui histórico no período de 2 meses
        </v-alert>
        <v-alert color="white--text red" :value="true" v-if="!historic.length && loading" class="ma-6">
          Carregando pedido...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-alert>
      </v-col>
      
      <!-- TIME LINE -->
    </v-row>

    
    <v-col cols="12" class="pa-0 pb-3 pt-3">
      <v-divider class="mb-3"></v-divider>
      <span class="ml-4"> <b> Mostrando a partir de {{start_date.format('DD/MM/YYYY')}} </b> </span>
      <v-btn color="primary" class="mx-1" small @click="setDatesToIndex" :disabled="loaded_historic"> {{loaded_historic ? 'Carregando...' : 'Carregar'}}
        <v-icon right small v-if="!loaded_historic">mdi-plus</v-icon>
        <v-progress-circular  v-if="loaded_historic" size="16" indeterminate color="primary" class="ml-3" width="2" ></v-progress-circular>
      </v-btn>
      <v-btn color="primary" class="mx-1" small @click="getHistoricPdf" >Baixar PDF<v-icon right small>mdi-file-pdf-box</v-icon></v-btn>
    </v-col>
  

    <v-dialog v-if="item_dialog" v-model="item_dialog" scrollable persistent :max-width="loading ? '500px' : '95%'">
      <v-card>
        <v-card-title class="d-flex align-center grey lighten-3 grey--text text--darken-3">
          <v-btn icon color="error" @click="closeItem" class="mr-2"><v-icon>mdi-close</v-icon></v-btn> 
          Detalhes do pagamento
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>

          <div class="pt-3">
            <b>Informações do pagamento</b>
          </div>
          <div class="pt-1">
            {{ solution_map[selected_item.solution] }} - {{ selected_item.place_name }} 
            {{selected_item.text}} 
            {{selected_item.comment && (!selected_item.wholesale_order_id && !selected_item.other_order_id)? selected_item.comment : ''}} 
            {{ (selected_item.wholesale_order_id || selected_item.other_order_id) ? ' Pedido: #' + (selected_item.wholesale_order_id || selected_item.other_order_id) : ''}}
          </div>
          <div class="pb-0">
            <v-chip class="ma-1" pill>
              <v-avatar left :class="financial_data[selected_item.type].chip[selected_item.kind].avatar_color">
                <v-icon small color="white">{{financial_data[selected_item.type].chip[selected_item.kind].icon}}</v-icon>
              </v-avatar>
              R$ {{Number(selected_item.ammount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}}
            </v-chip>
          </div>

          <ItemHistoricContent v-if="item_dialog && selected_item" :item="selected_item" @itemClicked="itemClicked" :financial_data="financial_data"></ItemHistoricContent>
          
          <dialog-payment-details v-if="item_details.dialog && item_dialog" :item="item_details" @close="handleCloseDialogItemDetails"></dialog-payment-details>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <f-btn cancel @click="closeItem"></f-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Api from '@/api/index';
import SolutionMap from '@/_backoffice/_registrations/mixins/solution_map.js'
import ItemHistoricHeader from './financial/ItemHistoricHeader.vue'
import ItemHistoricContent from './financial/ItemHistoricContent.vue'

export default {
  name:"ClientProfileFinancial",
  mixins: [SolutionMap],
  components: {
    FinancialConsolidation: () => import('./financial/ClientConsolidation.vue'),
    DialogReversal: () => import('./financial/ClientProfileReversal.vue'),
    DialogPaymentDetails: () => import('./financial/DialogPaymentDetails.vue'),
    ItemHistoricHeader,
    ItemHistoricContent,
  },
  props: {
    client_id: {
      type: Number,
    },
  },
  data() {
    return {
      isActive: false,
      search:'',
      panel: [],
      loading: false,
      item_dialog: false,
      selected_item: {},
      loading_historic: false,

      key: null,
      new_reversal: false,

      historic: [],
      item_details: {
        id: null,
        class: null,
        solution: null,
        place_name: null,
        dialog: false,
      },
      filter: null,
      financial_data: {
        payment: {
          dot_icon: 'mdi-swap-horizontal-bold',
          dot_color: 'success',
          chip: {
            check: {
              icon: 'mdi-checkbook',
              text: 'Cheque',
              avatar_color: 'green darken-2',
            },
            cash: {
              icon: 'mdi-cash',
              text: 'Dinheiro',
              avatar_color: 'green darken-2',
            },
            envelope: {
              icon: 'mdi-email',
              text: 'Envelope',
              avatar_color: 'red darken-2',
            },
            pay_devolution: {
              icon: 'mdi-undo',
              text: 'Devolução',
              avatar_color: 'green darken-3',
            },
            envelope: {
              icon: 'mdi-email',
              text: 'Envelope',
              avatar_color: 'green darken-2',
            },
            deposit: {
              icon: 'mdi-receipt',
              text: 'Depósito',
              avatar_color: 'green darken-3',
            },
            deposit_returned: {
              icon: 'mdi-receipt',
              text: 'Depósito',
              avatar_color: 'red darken-3',
            },
            exchange: {
              icon: 'mdi-swap-horizontal',
              text: 'Permuta',
              avatar_color: 'green darken-3',
            },
            bonus: {
              icon: 'mdi-cash-refund',
              text: 'Bônus',
              avatar_color: 'purple darken-2',
            },
          },
          icons: {
          },
        },
        bill: {
          dot_icon: 'mdi-swap-horizontal-bold',
          dot_color: 'success',
          chip: {
            bill: {
              icon: 'mdi-barcode',
              text: 'Boleto',
              avatar_color: 'green darken-4',
            },
          },
        },
        pix: {
          dot_icon: 'mdi-swap-horizontal-bold',
          dot_color: 'success',
          chip: {
            pix: {
              icon: 'mdi-qrcode',
              text: 'PIX',
              avatar_color: 'green darken-4',
            },
          },
        },
        vrt_transaction: {
          dot_icon: 'mdi-swap-horizontal-bold',
          dot_color: 'error',
          chip: {
            vrt_transaction: {
              icon: 'mdi-barcode',
              text: 'Boleto',
              avatar_color: 'red darken-3',
            },
          },
        },
        reversal: {
          dot_icon: 'mdi-swap-horizontal-bold',
          dot_color: 'purple darken-3',
          chip: {
            reversal: {
              icon: 'mdi-undo',
              text: 'Estorno',
              avatar_color: 'purple darken-3',
            },
          },
        },

      },

      start_date: this.$moment().subtract(2, 'month').startOf('month'),
      end_date: this.$moment().endOf('month'),

    }
  },
  computed: {
    loaded_historic(){
      return this.loading_historic
    },
    can_use_reversal() {
      return this.isDirector()
    },
    filtered_historic(){
      return this.historic.filter(item =>
        item?.ammount?.toLowerCase()?.includes(this.search.toLowerCase()) || 
        item?.text?.toLowerCase()?.includes(this.search.toLowerCase()) ||
        item?.comment?.toLowerCase()?.includes(this.search.toLowerCase()) ||
        String(item?.order_id)?.toLowerCase()?.includes(this.search.toLowerCase()) || 
        String(item?.ammount)?.toLowerCase()?.includes(this.search.toLowerCase()) || 
        String(this.$moment(item?.payed_at)?.format('DD/MM/YYYY'))?.toLowerCase()?.includes(this.search.toLowerCase())
      )
    },
  },
  methods: {
    closeItem(){
      this.selected_item = null
      this.item_dialog = false
      this.item_details.dialog = false
      this.handleCloseDialogItemDetails()
    },
    openItemDialog(item){
      this.item_dialog = !this.item_dialog
      this.selected_item = item
    },
    itemClicked(item_hf) {
      if (item_hf.id && ['payment', 'bill', 'pix'].includes(item_hf.type)) {
        this.item_details.id = item_hf.id
        this.item_details.class = item_hf.kind

        this.item_details.solution = item_hf.solution
        this.item_details.place_name = item_hf.place_name

        this.item_details.dialog = true
      }
    },
    handleCloseDialogItemDetails() {
      this.item_details.id = null
      this.item_details.class = null
      this.item_details.dialog = false
    },
    setDatesToIndex() {
      if (this.end_date) {
        const start = this.start_date.startOf('month')
        this.end_date = this.$moment(start).startOf('month') // this.end_date.subtract(2, 'month').endOf('month').subtract(3, 'hour')        //        .setMonth(this.end_date.getMonth() - 2);
        this.start_date = this.start_date.subtract(2, 'month').startOf('month')  //        .setMonth(this.start_date.getMonth() - 2);
      }
      this.getHistoric();
    },
    handleReversalCreated(e) {
      this.new_reversal = false
      if (e) {
        this.historic = [{ ...e }, ...this.historic]
      } else {
        this.getHistoric()
      }
    },
    getHistoricPdf() {
      Api.Financial.clientPaymentsPdf(this.client_id, true, this.start_date, null).then(r => r.data).then(hist => {
        const url = window.URL.createObjectURL(new Blob([hist], { type: 'application/pdf' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `histórico_cliente_${this.client_id}.pdf`);
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(link.href)
      }).catch((err) => {
        console.log({ err });
      })

    },
    getHistoric() {
      this.loading_historic = true
      this.loading = true
      let end_date = this.end_date.format('YYYY-MM-DD') == this.$moment().endOf('month').format('YYYY-MM-DD') ? this.end_date.add(3, 'months').format('YYYY-MM-DD') : this.end_date.format('YYYY-MM-DD')
      Api.Financial.clientPayments(this.client_id, true, this.start_date.format('YYYY-MM-DD'), end_date)
        .then(r => r.data)
        .then(hist => {
          let msg = hist.length ? 'Feito com sucesso' : `Sem registros de ${this.$moment(this.start_date).format('DD/MM/YYYY')} - ${this.$moment(this.end_date).format('DD/MM/YYYY')}`;
          let type = hist.length ? 'success' : 'error';
          this.addNotification({type, msg})
          this.historic = [
            ...this.historic,
            ...hist
          ]
        })
        .finally(() =>{
          this.loading = false
          this.loading_historic = false
        })
    },
    ...mapActions({
      addNotification: 'Notification/add',
    }),
  },
  mounted() {
    this.getHistoric();
  },
}
</script>